import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "@/serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Buffer } from "buffer";
import { Provider as RollbarProvider, ErrorBoundary } from "@rollbar/react";
import rollbar from "./rollbar";

import store from "./store";

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <RollbarProvider instance={rollbar}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </RollbarProvider>
    </BrowserRouter>
  </Provider>
);

window.Buffer = window.Buffer || Buffer;
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(app);

serviceWorker.unregister();
